import { apiClient } from './client'

export interface LoginRequest {
    email?: string
    password?: string
}

export interface ChangePasswordRequest {
    currentPassword?: string
    newPassword?: string
}

export interface ResetPasswordRequest {
    token: string
    newPassword: string
}

export interface AuthResponse {
    success: boolean
    message: string
    data: {
        user: any
        tokens: {
            accessToken: string
            refreshToken: string
            expiresIn: number
        }
    }
}

export const authService = {
    login: async (credentials: LoginRequest) => {
        const response = await apiClient.post<AuthResponse>('/admin/auth/login', credentials)
        return response.data
    },

    logout: async () => {
        return apiClient.post('/admin/auth/logout')
    },

    refreshToken: async (refreshToken: string) => {
        return apiClient.post<{ success: true, data: { tokens: any } }>('/admin/auth/refresh', { refreshToken })
    },

    getProfile: async () => {
        return apiClient.get('/admin/auth/me')
    },

    forgotPassword: async (email: string) => {
        return apiClient.post<{ success: boolean; message: string }>('/admin/auth/forgot-password', { email })
    },

    resetPassword: async (data: ResetPasswordRequest) => {
        return apiClient.post<{ success: boolean; message: string }>('/admin/auth/reset-password', data)
    },

    changePassword: async (data: ChangePasswordRequest) => {
        return apiClient.post<{ success: boolean; message: string }>('/admin/auth/change-password', data)
    },

    updateProfile: async (data: { name?: string; avatarUrl?: string }) => {
        const response = await apiClient.put<{ success: boolean; data: { user: any } }>('/admin/auth/profile', data)
        return response.data
    }
}


